module.exports = __webpack_public_path__ + "img/banner.55eee442.png";